import React, {useState, useEffect} from 'react'
import { Container } from 'react-bootstrap'
import LeftHeading from '../../../../Components/Accounts/LeftHeading/LeftHeading'
import MultiItemsGrid from '../../../../Components/Accounts/MultiItemsGrid/MultiItemsGrid'
import Section from '../../../../Components/Section/Section'
import { getResponseError, getUserDetailsCookie } from '../../../../Api/Utils/apiUtils'
import EventApi from '../../../../Api/EventApi'
import SupplierFilterBox from '../../../../Components/Accounts/Supplier/SupplierFilterBox/SupplierFilterBox'
import Select from 'react-select'
import BusinessDetailsApi from '../../../../Api/BusinessDetailsApi'
import ErrorAlert from '../../../../Components/Form/ErrorAlert/ErrorAlert'
import SupplierCard from '../../../../Components/Accounts/Supplier/SupplierCard/SupplierCard'
import SupplierNavigation from '../../../../Components/Accounts/Supplier/SupplierNavigation/SupplierNavigation'
import ScaleLoader from "react-spinners/ScaleLoader";


const SupplierComponent = () => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [suppliers, setsuppliers] = useState(null)
    const [selectedCategory, setselectedCategory] = useState('')
    const [searchText, setsearchText] = useState('')
    const [supplierCategories, setsupplierCategories] = useState(null)
    const [fromPage, setfromPage] = useState(0)
    const [toPage, settoPage] = useState(15)
    const [customerId, setcustomerId] = useState(null)
    const [isloading, setisloading] = useState(true)


    const ErrorTimeOut = () => {
        setTimeout(() => {
            setErrorMessage(null)
        }, 6000);
    }

    // filter category onchange
    function filterDataonChange(data) {
        let filterabledata = ''
        for (let x = 0; x < data.length; x++) {
            if (data.length === x+1) {
                filterabledata = `${filterabledata}${data[x].value}`
            }else{
                filterabledata = `${filterabledata}${data[x].value},`
            }
        }
        setselectedCategory(filterabledata)
        filterabledata = ''
    }

    // clear Filter Info
    const clearFilterInfo = () => {
        setsearchText('')
        setselectedCategory('')
        filterWithNewData(0, 15, '', '')
    }

    // page wize work
    const pagecalculate = () => {
        setfromPage(fromPage+15)
        settoPage(toPage+15)
        filterWithNewData(fromPage+15, toPage+15)
    }


    //filter with new data 
    const filterWithNewData = async (from = 0, to = 15, text = searchText, category = selectedCategory) => {
        const  user = getUserDetailsCookie()
        const event = await EventApi.getEvent(user.id)
        const eventApiError = getResponseError(event)
        if (eventApiError) {
            setErrorMessage(eventApiError)
            ErrorTimeOut()
        }else{
            const eventsdata = event.objectVal
            const eventId = eventsdata[0].id
            const response = await EventApi.getSupplierList(eventId ? eventId : 20274, text, from, to, category)
            const responseApiError = getResponseError(response)
            if (responseApiError) {
                setErrorMessage(responseApiError)
                ErrorTimeOut()
            }else{
                const supplierinfo = response.objectVal
                setsuppliers(supplierinfo)
            }
        }
    }


    useEffect(() => {
        const loadCategories = async () => {
            const categorydata = await BusinessDetailsApi.getCategoryKeywordList()
            const categoryApiError = getResponseError(categorydata)
            if (categoryApiError) {
                setErrorMessage(categoryApiError)
                ErrorTimeOut()
            }else{
                const categoryList =  categorydata.objectVal
                const categoryinfo = categoryList.businessCategoryInfo
                const categorymodification = []
                categoryinfo.forEach(element => {
                    categorymodification.push({label:element.title, value: element.id})
                });
                setsupplierCategories(categorymodification)
            }
        }
        //all supplier
        const loadSuppliers = async () => {
            const  user = getUserDetailsCookie()
            setcustomerId(user.id)
            const event = await EventApi.getEvent(user.id)
            const eventApiError = getResponseError(event)
            if (eventApiError) {
                setErrorMessage(eventApiError)
                ErrorTimeOut()
            }else{
                const eventsdata = event.objectVal
                const eventId = eventsdata[0].id
                const response = await EventApi.getSupplierList(eventId ? eventId : 20274, '', 0, 15, '')
                const responseApiError = getResponseError(response)
                if (responseApiError) {
                    ErrorTimeOut()
                    setErrorMessage(responseApiError)
                    setisloading(false)
                }else{
                    const supplierinfo = response.objectVal
                    setsuppliers(supplierinfo)
                    setisloading(false)
                }
            }
        }
        loadCategories()
        loadSuppliers()
    }, [])

    return (
        <>
        {isloading ? 
            <div className="loading-section">
                <ScaleLoader color={'#591EC1'} loading={isloading} size={40} />
            </div>
        :
        <Section contStyle={{minHeight: "90vh", backgroundColor: "#f5f5f5", marginBottom: "80px"}}>
            {(suppliers && supplierCategories) &&
            <Container>
                <LeftHeading>Suppliers</LeftHeading>
                <>
                    <SupplierFilterBox>
                        <input type="text" placeholder='Find by supplier name ..' value={searchText} onChange={(e) => setsearchText(e.target.value)} />
                        <Select isMulti={true} placeholder="filter by category" options={supplierCategories} onChange={(e) => filterDataonChange(e)} />
                        <button className='filter' onClick={() => filterWithNewData(0, 15)}>Filter</button>
                        <button className='clear' onClick={clearFilterInfo}>Clear</button>
                    </SupplierFilterBox>
                    <ErrorAlert>{errorMessage}</ErrorAlert>
                    <MultiItemsGrid itemsPerRow={3}>
                        {
                            suppliers && suppliers.length > 0 &&
                            suppliers.map((supplierdata, i) => (
                                <SupplierCard key={`SUPPLIER${i}`} customerId={customerId} supplierInfo={supplierdata} />
                            ))
                        }
                    </MultiItemsGrid>
                    {suppliers && suppliers.length > 14 &&
                    <SupplierNavigation>
                        <button onClick={pagecalculate} className='next'>Load more</button>
                    </SupplierNavigation>}
                </>
            </Container>}
        </Section>}
        </>
    )
}

export default SupplierComponent
